export const ACTIONS = ['ALL', 'CREATE', 'DELETE', 'UPDATE', 'READ', 'NONE']

export const ROLES = [
  'root', //root
  'owner', //owner
  'admin', //admin
  'brandManager', //brandManager
  'delegationManager', //delegationManager
  'operator', //'rootDelegationOperative', //operator
  'comunityManager',
  'rootDelegationMarketing', //comunityManager
  'user', //null
]
